import { render, staticRenderFns } from "./RequestEndorsementSelectedPolicy.vue?vue&type=template&id=4a58fca2"
import script from "./RequestEndorsementSelectedPolicy.vue?vue&type=script&lang=js"
export * from "./RequestEndorsementSelectedPolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports